<template>
    <span class="caption tabular-nums" style="white-space: nowrap">{{ start | format_time }} - {{ end | format_time }}</span>
</template>

<script>
export default {
    name: "RichDataTableTimePeriod",
    props: {
        start: {
            type: String,
            default: null
        },
        end: {
            type: String,
            default: null
        }
    }
};
</script>
